
import { Component, Vue } from 'vue-property-decorator';
import { BirthAuth } from '@/api';
import ApiCancelError from '@/resources/error/ApiCancelError';
import ApiModalError from '@/resources/error/ApiModalError';
import PageHeader from '@/components/PageHeader.vue';
import TopFooterButton from '@/components/TopFooterButton.vue';
import TopContentText from '@/components/TopContentText.vue';
import TopContentCautionSingle from '@/components/TopContentCautionSingle.vue';
import { KycOrgConfig } from '@/api/auth';
import { isIncident } from '@/resources/application';
import { KycRequests } from '@/api';

@Component({
  components: {
    PageHeader,
    TopFooterButton,
    TopContentText,
    TopContentCautionSingle
  }
})
export default class InputBirthday extends Vue {
  private isLastLoading: boolean = false;
  private year: number = this.currentYear - 30;
  private month: number = 1;
  private date: number = 1;

  private get isIncident(): boolean {
    return isIncident;
  }

  private get isDayMonthYear(): boolean {
    if (this.$i18n.locale == 'en') return true;
    if (this.$i18n.locale == 'id') return true;
    if (this.$i18n.locale == 'ms') return true;
    if (this.$i18n.locale == 'th') return true;
    if (this.$i18n.locale == 'vi') return true;
    return false;
  }

  private get descriptions(): string[] {
    const description: string = this.$t('202309_103') as string;
    return this.$store.getters['camera/isPC'] ? [description.replace('<br>', '')] : description.split('<br>');
  }

  // 今年
  get currentYear(): number {
    return new Date().getFullYear();
  }

  // ボタン有効確認
  get enabled(): boolean {
    return this.year > 0 && this.month > 0 && this.date > 0;
  }

  // 次のページへ行く
  private async next(): Promise<void> {
    try {
      this.isLastLoading = true;
      await this.$store.dispatch('auth/storeBirthAuth', {
        year: this.year,
        month: this.month,
        date: this.date
      });

      // 生年月日認証がONの場合、アクセストークンはここで取得できるので、ここでClientTypeを送信
      const kycRequestId: number = this.$store.getters['auth/kycRequestID'];
      const kycOrgConfig: KycOrgConfig = this.$store.getters['auth/kycOrgConfig'];
      const isFetchClientTypes: boolean = kycOrgConfig.enableClientTypePC;
      if (isFetchClientTypes) await KycRequests.fetchClientTypes(kycRequestId, this.$store.getters['camera/isPC']);

      // 利用規約にすでに同意している
      const checkTermsOfService: KycOrgConfig = this.$store.getters['auth/kycOrgConfigCheckTermsOfService'];
      const agreedTermsOfService: boolean = this.$store.getters['terms/agreedTermsOfService'];
      if (!checkTermsOfService || agreedTermsOfService) {
        this.$router.push('/top/personal-information');
        return;
      }

      this.$router.push({ name: 'terms' });
    } catch (error) {
      if (error instanceof ApiCancelError) {
        // キャンセルは握りつぶす
      } else if (error instanceof ApiModalError) {
        // clientRetryableで処理したエラーは握りつぶす
      } else throw error;
    } finally {
      this.isLastLoading = false;
    }
  }
}
